import React, { memo } from "react";
import { ComposableMap, Geographies, Geography } from "react-simple-maps";
import { useProjectContext } from "./context/projectsContext";

const colorTurquoise = "#22cbc7";
const colorPink = "#cc31ca";
const colorBlue = "#062f6e";
const grayColor = "#eeeeee";
const colorYellow = "#E496E6";

const geoUrl = "/li-map-svg/world-110m.json";
// const geoUrl = "/world-110m.json";

const MapChart = () => {
  const {
    countryList,
    ourOffices,
    setTooltipContent,
    selectedCountry,
    setSelectedCountry,
    projects,
    hoveredCountry,
    filteredProjects,
  } = useProjectContext();

  const isInList = (country, isPressed) => {
    let findCountry = countryList.find((c) => c === country);
    return !!findCountry;
  };

  const hasProjects = () => {
    let foundProjects = projects.filter((p) =>
      p.country.includes(hoveredCountry)
    );
    // console.log(!!foundProjects.length, hoveredCountry);
    return !!foundProjects.length;
  };
  const isOurOffice = (country) => {
    let findCountry = ourOffices.find((c) => c === country);
    return !!findCountry;
  };
  const fillCountry = (country) => {
    if (selectedCountry === country) {
      if (isOurOffice(selectedCountry)) {
        if (filteredProjects) {
          return colorTurquoise;
        } else {
          return colorPink;
        }
      }
      return colorTurquoise;
    }
    if (isInList(country)) {
      if (isOurOffice(country)) {
        return colorPink;
      } else {
        return colorBlue;
      }
    }
    return grayColor;
  };

  const hoverCountry = (country) => {
    if (selectedCountry === country) {
      if (hasProjects(selectedCountry)) {
        return colorTurquoise;
      } else {
        return colorPink;
      }
    }
    if (isInList(country)) {
      if (isOurOffice(country)) {
        if (hasProjects(selectedCountry)) {
          return colorYellow;
        } else {
          return colorPink;
        }
      } else {
        return colorPink;
      }
    }

    return grayColor;

    // hover: {
    //   fill:
    //     selectedCountry === NAME
    //       ? "#22cbc7"
    //       : isInList(NAME)
    //       ? isOurOffice(NAME)
    //         ? "#22cbc7"
    //         : "#cc31ca"
    //       : grayColor,
    //   outline: "none",
    // },

    // "#22cbc7"
    //                         : isInList(NAME)
    //                         ? isOurOffice(NAME)
    //                           ? "#22cbc7"
    //                           : colorPink
  };
  return (
    <div className="relative">
      <ComposableMap
        data-tip=""
        projectionConfig={{
          scale: 240,
          center: [-20, -8],
        }}
      >
        {/* <ZoomableGroup> */}
        <Geographies geography={geoUrl}>
          {({ geographies }) =>
            geographies.map((geo) => {
              const { NAME } = geo.properties;
              return (
                <React.Fragment key={geo.rsmKey}>
                  <Geography
                    stroke="#FFF"
                    strokeWidth={0.2}
                    geography={geo}
                    onMouseDownCapture={() => {
                      if (isInList(NAME))
                        setSelectedCountry(geo.properties.NAME);
                    }}
                    onMouseEnter={() => {
                      if (isInList(NAME)) setTooltipContent(`${NAME}`);
                    }}
                    onMouseLeave={() => {
                      setTooltipContent("");
                    }}
                    style={{
                      default: {
                        fill: fillCountry(NAME),
                        outline: "none",
                      },
                      hover: {
                        fill: hoverCountry(NAME),
                        outline: "none",
                      },
                      pressed: {
                        fill: isInList(NAME, true)
                          ? fillCountry(NAME)
                          : grayColor,
                        outline: "none",
                      },
                    }}
                  />
                  {/* {console.log(geo.geometry.coordinates[0][0][0])} */}
                </React.Fragment>
              );
            })
          }
        </Geographies>
        {/* </ZoomableGroup> */}
      </ComposableMap>
    </div>
  );
};

export default memo(MapChart);
